export const categoryFrag = `
    id
    name
    code
    active
`